import kanbanService, { KanbanStatuses } from "./kanbanService";

const KanbanStatusesPreferenceService = {
  async getSelectedStatuses(): Promise<string[]> {
    const data = await kanbanService.get();

    if (!data || typeof data !== "object") return [];

    const value = (data as KanbanStatuses).value;

    if (typeof value !== "string" || value.trim() === "") {
      return [];
    }

    try {
      const parsed = JSON.parse(value);

      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (err) {
      console.error("Failed to parse kanban status value:", err);
      return [];
    }
  },
  async saveSelectedStatuses(statusIds: string[]): Promise<void> {
    const value = JSON.stringify(statusIds);
    await kanbanService.Save(value);
  },
};

export default KanbanStatusesPreferenceService;
